import {
  PocBlocksSchema,
  type PocBlocks,
} from '@terra/shared-schemas-orchestrator';

const MAX_POC_HTTP_TEXT_LENGTH = 2000;

function capPocHttpText(text: string, harId?: string | null): string {
  if (text.length <= MAX_POC_HTTP_TEXT_LENGTH) {
    return text;
  }

  const harHint = harId ? ` — fetch HAR ${harId} for the full text` : '';

  return `${text.slice(0, MAX_POC_HTTP_TEXT_LENGTH)}\n… [truncated ${text.length - MAX_POC_HTTP_TEXT_LENGTH} chars${harHint}]`;
}

function serializePocBlocks(pocBlocks: PocBlocks): string {
  return pocBlocks
    .map((block) => {
      if (block.type === 'narrative') {
        return block.content;
      }

      if (block.type === 'image') {
        return block.caption
          ? `Image: ${block.fileName}\n${block.caption}`
          : `Image: ${block.fileName}`;
      }

      const parts = [block.explanation];

      if (block.whyItMatters) {
        parts.push(`Why it matters: ${block.whyItMatters}`);
      }

      if (block.manualRequest) {
        parts.push(
          `Request:\n${capPocHttpText(block.manualRequest, block.toolExecutionHarId)}`,
        );
      }

      if (block.manualResponse) {
        parts.push(
          `Response:\n${capPocHttpText(block.manualResponse, block.toolExecutionHarId)}`,
        );
      }

      return parts.join('\n');
    })
    .join('\n\n');
}

export function parseEditablePocBlocks(value: unknown): PocBlocks | null {
  const parsed = PocBlocksSchema.safeParse(value);

  return parsed.success ? parsed.data : null;
}

export function getFindingPocText({
  poc,
  pocBlocks,
}: {
  poc?: string | null;
  pocBlocks?: PocBlocks | null;
}): string | null {
  if (poc) {
    return poc;
  }

  if (pocBlocks && pocBlocks.length > 0) {
    return serializePocBlocks(pocBlocks);
  }

  return null;
}
